import { PayloadAction } from '@reduxjs/toolkit';
import { IRootState } from './types';

const reducers = {
  setSheets: (state: IRootState, action: PayloadAction<IRootState['sheets']>) => ({
    ...state,
    sheets: action.payload,
  }),
  setSearchedSheets: (state: IRootState, action: PayloadAction<IRootState['sheets']>) => ({
    ...state,
    searchedSheets: action.payload,
  }),
  setSelectedMember: (state: IRootState, action: PayloadAction<IRootState['selectedMember']>) => ({
    ...state,
    selectedMember: action.payload,
  }),
  setSelectedShift: (state: IRootState, action: PayloadAction<IRootState['selectedShift']>) => ({
    ...state,
    selectedShift: action.payload,
  }),
  setToggleDeleteShift: (state: IRootState, action: PayloadAction<IRootState['isOpenDeleteShiftDialog']>) => ({
    ...state,
    isOpenDeleteShiftDialog: action.payload,
  }),
  setIsOpenEmployeesExportMode: (state: IRootState, action: PayloadAction<IRootState['isOpenEmployeesExportMode']>) => ({
    ...state,
    isOpenEmployeesExportMode: action.payload,
  }),
  setSelectedMembers: (state: IRootState, action: PayloadAction<IRootState['selectedMembers']>) => ({
    ...state,
    selectedMembers: action.payload,
  }),
  setFilteredSheets: (state: IRootState, action: PayloadAction<IRootState['filteredSheets']>) => ({
    ...state,
    filteredSheets: action.payload,
  }),
  setSelectedLocationId: (state: IRootState, action: PayloadAction<IRootState['selectedLocationId']>) => ({
    ...state,
    selectedLocationId: action.payload,
  }),
};

export {
  reducers,
};
